const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl && !envUrl.includes("localhost") && !envUrl.includes("127.0.0.1")) {
    return envUrl;
  }
  if (typeof window !== "undefined" && window.location) {
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";
    if (!isLocalhost) {
      return window.location.origin;
    }
  }
  return envUrl || "http://localhost:8000";
};

const BASE_URL = getApiBaseUrl();

export function resolvePhotoUrl(photo) {
  if (!photo) return null;
  
  let targetPath = photo;
  
  // If it is a full URL, check if it points to a local or mismatching backend server (e.g., IIS internal mapping)
  if (photo.startsWith("http")) {
    try {
      const urlObj = new URL(photo);
      const isLocalHost =
        urlObj.hostname === "localhost" ||
        urlObj.hostname === "127.0.0.1" ||
        urlObj.port === "8000";
        
      if (isLocalHost) {
        // Extract the path portion (e.g., "/media/profile_photos/user.jpg")
        targetPath = urlObj.pathname + urlObj.search;
      } else {
        return photo; // Keep as-is if it's already a valid external absolute URL
      }
    } catch (e) {
      // Fallback: extract substring starting from /media/
      const mediaIdx = photo.indexOf("/media/");
      if (mediaIdx !== -1) {
        targetPath = photo.substring(mediaIdx);
      }
    }
  }
  
  const path = targetPath.startsWith("/") ? targetPath : `/media/${targetPath}`;
  return `${BASE_URL}${path}`;
}
